<div mat-dialog-content *ngIf="type == 'toppers'"> 
  <ng-container *ngIf="data?.viewtype == 'video' || !data?.viewtype"> 
    <object class="videotab" style="width: 100%;
    height: 64vh;" [data]="video">
      <param name="movie" 
             [value]="video"/>
      <param name="allowScriptAccess" value="always"/>
    </object>
  </ng-container>
  <ng-container *ngIf="data?.viewtype == 'image'"> 
   <img [src]="data?.video" style="width:100%;">
  </ng-container>
  <div class="desk-none">
    <button class="align-center " (click)="close()" mat-button>Close</button>
  </div>
</div>



<div mat-dialog-content *ngIf="type != 'toppers'">
  <div class="row">
<div class="col-md-8" style="padding-top: 5px;padding-left: 20px;">
  <object class="videotab" style="width: 100%;
  height: 63vh;" [data]="video">
    <param name="movie" 
           [value]="video"/>
    <param name="allowScriptAccess" value="always"/>
  </object>
</div>
<div class="col-md-4 pl-md-0 justify-content-center">
<div>

    <div class="infodiv">
        <img alt=""src="https://media.iquanta.in/ui_images/public_portal_img/video_info_p_opt.png">
        <div class="contdiv">
          <p >Build your Own Success Today</p>
          <p>Be a part of Our Learning Network</p>
          <h4>Contact us to know more</h4>
          <p>info@iquanta.in</p>
          <p>+91 8130900243</p>
        </div>
        <button class="desk-now-show" (click)="close()" mat-button>Close</button>
    </div>
</div>
</div>
  </div>
 


 

 
</div>

<div class="closebtn" (click)="close()">
  <span class="material-icons">
    close
    </span>
</div>